import React from 'react'
import {Route, Switch, withRouter} from 'react-router-dom'
import $ from 'jquery';
import AuthenticatedRoute from './AuthenticatedRoute'
import Login from '../componentes/auth/Login'
import Logout from '../componentes/auth/Logout'
import {setBrowserHistory} from '../util/applicationContext'
import PainelGerenciarEmpresas from '../componentes/empresa/PainelGerenciarEmpresas';
import PainelGerenciarUsuario from '../componentes/usuario/empresa/PainelGerenciarUsuario';
import PainelGerenciarTrechos from '../componentes/trecho/PainelGerenciarTrecho'
import PainelGerenciarVeiculos from '../componentes/veiculo/PainelGerenciarVeiculos'
import PainelGerenciarRotas from '../componentes/rota/PainelGerenciarRotas';
import PainelGerenciarItinerarios from '../componentes/itinerario/PainelGerenciarItinerarios';
import PainelGerenciarPreco from '../componentes/preco/PainelGerenciarPreco';
import PainelGerenciarPedidos from '../componentes/pedido/PainelGerenciarPedido';
import PainelGerenciarPedidoGeral from '../componentes/pedido/geral/PainelGerenciarPedidoGeral';
import PaginaValidarCliente from '../componentes/usuario/empresa/PaginaValidarCliente';
import PaginaTrocaSenha from '../componentes/usuario/empresa/PaginaTrocaSenha';
import PaginaPrincipalEmpresa from '../componentes/PaginaPrincipalEmpresa';
import PainelFechamentoCaixa from '../componentes/fechamento-caixa/usuario/PainelFechamentoCaixa';
import PainelGerenciarCidades from '../componentes/cidade/PainelGerenciarCidades';
import PainelCadastroVeiculo from '../componentes/mapa-veiculo/PainelCadastroMapaVeiculo';
import PainelGerenciarMapasVeiculos from '../componentes/mapa-veiculo/PainelGerenciarMapasVeiculos';
import MenuEncomendas from '../componentes/encomenda/MenuEncomendas';
import MenuBagagem from '../componentes/bagagem/MenuBagagem';
import PainelGerenciarEncomendas from '../componentes/encomenda/PainelGerenciarEncomendas';
import PainelCadastroEncomenda from '../componentes/encomenda/PainelCadastroEncomenda';
import PesquisarBilhete from '../componentes/bagagem/PesquisarBilhete';
import PainelCadastroBagagem from '../componentes/bagagem/PainelCadastroBagagem';
import PainelGerenciarBagagens from '../componentes/bagagem/PainelGerenciarBagagens';
import ReciboEncomenda from '../componentes/encomenda/ReciboEncomenda';
import ReciboBagagem from '../componentes/bagagem/ReciboBagagem';
import SelecaoEmpresaAtuacao from '../componentes/selecao-empreas/PaginaSelecaoEmpresaAtuacao';
import PaginaPrincipalGestao from '../componentes/PaginaPrincipalGestao';
import RedirectPagina from '../componentes/RedirectPagina';
import PainelGerenciarAgencias from '../componentes/agencia/PainelGerenciarAgencias';
import PainelBloqueioPoltrona from '../componentes/itinerario/PainelBloqueioPoltrona';
import ReciboPassagem from '../componentes/pedido/PainelReciboPassagem';
import PainelPassageirosItinerario from '../componentes/itinerario/PainelPassageirosItinerario';
import PainelVenderPassagem from '../componentes/viagem/PainelVenderPassagem';
import PainelMapaViagemItinerario from '../componentes/itinerario/PainelMapaViagemItinerario';
import PainelGerenciarRemarcacao from '../componentes/remarcacao/PainelGerenciarRemarcacao';
import PainelDetalhamentoFechamentoCaixa
  from '../componentes/fechamento-caixa/usuario/PainelDetalhamentoFechamentoCaixa';
import PainelDetalhamentoFinanceiroItinerario from '../componentes/itinerario/PainelDetalhamentoFinanceiroItinerario';
import ReciboCancelamentoReserva from '../componentes/remarcacao/ReciboCancelamentoReserva';
import PainelAlteracaoPoltrona from '../componentes/remarcacao/PainelAlteracaoPoltrona';
import PainelConfiguracaoBPe from '../componentes/configuracao-bpe/PainelConfiguracaoBPe';
import PainelUsuarioBloqueado from '../componentes/PainelUsuarioBloqueado';
import PainelFechamentoCaixaAgencia from '../componentes/fechamento-caixa/agencia/PainelFechamentoCaixaAgencia';
import PainelDetalhamentoFechamentoCaixaAgencia
  from '../componentes/fechamento-caixa/agencia/PainelDetalhamentoFechamentoCaixaAgencia';
import MenuFechamentoCaixa from '../componentes/fechamento-caixa/MenuFechamentoCaixa';
import MenuRelatorio from '../componentes/relatorio/MenuRelatorio';
import MenuUsuario from '../componentes/usuario/MenuUsuario';
import PainelResumoFinanceiro from '../componentes/relatorio/resumo-financeiro/PainelResumoFinanceiro';
import PaginaErro from '../componentes/PaginaErro';
import PainelRelatorioItinerarios from '../componentes/relatorio/itinerario/PainelRelatorioItinerarios';
import PainelGerenciarUsuariosPlataforma from '../componentes/usuario/plataforma/PainelGerenciarUsuariosPlataforma';
import PainelGerenciarUsuariosAgencia from '../componentes/usuario/agencia/PainelGerenciarUsuariosAgencia.js';
import MenuItinerario from '../componentes/itinerario/MenuItinerario';
import PainelEmbarquePassageiros from '../componentes/itinerario/PainelEmbarquePassageiros';
import PainelEmbarqueComQrCode from '../componentes/itinerario/PainelEmbarqueComQrCode';
import PainelGerenciarCupom from '../componentes/cupom/PainelGerenciarCupom';
import PainelCadastroUsuarioEmpresaEmLote from '../componentes/usuario/empresa/PainelCadastroUsuarioEmpresaEmLote';
import PainelRecibosItinerario from '../componentes/itinerario/PainelRecibosItinerario';
import PainelGerenciarInteressadosPromocao from '../componentes/interessado-promocao/PainelGerenciarInteressadosPromocao';
import PainelGerenciarUsuarioSistema from '../componentes/usuario/PainelGerenciarUsuarioSistema';
import PainelRelatorioGerencial from '../componentes/relatorio/gerencial/PainelRelatorioGerencial';
import PainelGerenciarPrestadores from '../componentes/prestador/PainelGerenciarPrestadores';
import PainelAtivacaoItineracioEmLote from '../componentes/itinerario/PainelAtivacaoItineracioEmLote';
import PainelConfiguracaoBilhete from '../componentes/configuracao-bilhete/PainelConfiguracaoBilhete';
import PainelVexadoBI from '../componentes/vexado-bi/PainelVexadoBI';
import PainelGerenciarRepasseVenda from '../componentes/repasse-venda/PainelGerenciarRepasseVenda';
import PainelResumoRepasse from '../componentes/repasse-venda/PainelResumoRepasse.js';
import PainelReservasRepasse from '../componentes/repasse-venda/PainelReservasRepasse';
import PainelDetalhamentoFinanceiroItinerarioEncomenda from '../componentes/itinerario/PainelDetalhamentoFinanceiroItinerarioEncomenda';
import PainelConfiguracaoBpeReserva from '../componentes/itinerario/PainelConfiguracaoItinerarioReservasBpe';
import PainelGerenciarDisponiveisInternet from '../componentes/disponiveis-internet/PainelGerenciarDisponiveisInternet';
import PainelTransferirPassageirosItinerarios from '../componentes/itinerario/PainelTransferirPassageirosItinerario';
import ItinerariosParaTransferencia from '../componentes/itinerario/ItinerariosParaTransferencia';
import PainelCadastrarVeiculo from '../componentes/veiculo/PainelCadastrarVeiculo';
import PainelGerenciarCalendariosDisponibilidadeVeiculo from '../componentes/disponibilidade-veiculo/PainelGerenciarCalendariosDisponibilidadeVeiculo';
import PainelCadastroCalendarioDisponibilidadeVeiculo from '../componentes/disponibilidade-veiculo/PainelCadastroCalendarioDisponibilidadeVeiculo';
import PainelConfiguracaoEncomendas from '../componentes/encomenda/PainelConfiguracaoEncomendas';
import PainelGerenciarAgendamentoViagem from '../componentes/agendamento-viagem/PainelGerenciarAgendamentoViagem';
import PainelCadastroAgendamentoViagem from '../componentes/agendamento-viagem/PainelCadastroAgendamentoViagem';
import PainelPassageirosAgendamentoViagem from '../componentes/agendamento-viagem/PainelPassageirosAgendamentoViagem';
import PainelGerenciarAgrupadoCalendarioDisponibilidadeVeiculo from '../componentes/disponibilidade-veiculo/PainelGerenciarAgrupadoCalendarioDisponibilidadeVeiculo';
import PainelGerenciarEmissaoCteOS from '../componentes/cteos/PainelGerenciarEmissaoCteOS';
import PainelCadastroEmissaoCteOS from '../componentes/cteos/PainelCadastroEmissaoCteOS';
import PainelGerenciarTomador from '../componentes/cteos/PainelGerenciarTomador';
import MenuCteos from '../componentes/cteos/MenuCteos';
import PainelConfirmarEntregaEncomendas from '../componentes/encomenda/PainelConfirmarEntregaEncomendas';
import PainelGerenciarEncomendasItinerario from '../componentes/encomenda/PainelGerenciarEncomendasItinerario';
import PainelNotaFiscalCteOs from '../componentes/cteos/PainelNotaFiscalCteOs';
import PainelNotaFiscalCte from '../componentes/encomenda/PainelNotaFiscalCte';
import PainelRegistrarManutencaoVeiculo from '../componentes/veiculo/PainelRegistrarManutencaoVeiculo.js';
import MenuAdesaoPontos from '../componentes/adesao-pontos/MenuAdesaoPontos.js';
import PainelCadastroConfiguracaoPonto from '../componentes/adesao-pontos/PainelCadastroConfiguracaoPonto.js';
import PainelGerenciarAdesaoPontos from '../componentes/adesao-pontos/PainelGerenciarAdesaoPontos.js';
import MenuAdesaoPontosEmpresa from '../componentes/adesao-pontos/MenuAdesaoPontosEmpresa.js';
import PainelCadastroConfiguracaoConsumoPonto from '../componentes/adesao-pontos/PainelCadastroConfiguracaoConsumoPonto.js';
import PainelGerenciarClientesEmpresa from '../componentes/adesao-pontos/PainelGerenciarClientesEmpresa';
import PainelRelatorioGerencialAgencia from '../componentes/relatorio/gerencial/PainelRelatorioGerencialAgencia.js';
import PainelRegistrarCentroCusto from '../componentes/centro-custo/PainelRegistrarCentroCusto'
import PainelMensagemAutenticacaoDoisFatores from '../componentes/auntenticacaoDoisFatores/PainelMensagemAutenticacaoDoisFatores.js';
import PainelAutenticacaoDoisFatores from '../componentes/auntenticacaoDoisFatores/PainelAutenticacaoDoisFatores.js';


export class AppRoutes extends React.Component {
  constructor(props) {
    super(props);
    const {history} = this.props;
    setBrowserHistory(history)
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidUpdate() {
    $('.modal-backdrop')
      .remove();
    $('body')
      .removeClass('modal-open');
  }

  render() {
    return (
      <Switch>
        <Route path='/login' component={Login}/>
        <Route path='/painel-autenticacao-dois-fatores' component={PainelAutenticacaoDoisFatores}/>
        <Route path='/logout' component={Logout}/>
        <Route path='/validar-cliente' component={PaginaValidarCliente}/>
        <Route path='/troca-senha' component={PaginaTrocaSenha}/>
        <Route path='/erro' component={PaginaErro}/>

        <AuthenticatedRoute path='/painel-empresas' component={PainelGerenciarEmpresas}/>

        <AuthenticatedRoute path='/painel-prestadores' component={PainelGerenciarPrestadores}/>

        <AuthenticatedRoute path='/painel-cidades' component={PainelGerenciarCidades}/>

        <AuthenticatedRoute path='/painel-usuarios' component={PainelGerenciarUsuario}/>

        <AuthenticatedRoute path='/painel-cadastro-usuarios-empresa-lote'
                            component={PainelCadastroUsuarioEmpresaEmLote}/>

        <AuthenticatedRoute path='/painel-usuarios-sites' component={PainelGerenciarUsuariosPlataforma}/>

        <AuthenticatedRoute path='/painel-usuarios-agencia' component={PainelGerenciarUsuariosAgencia}/>

        <AuthenticatedRoute path='/painel-usuarios-sistema' component={PainelGerenciarUsuarioSistema}/>

        <AuthenticatedRoute path='/painel-trechos' component={PainelGerenciarTrechos}/>

        <AuthenticatedRoute path='/painel-rotas' component={PainelGerenciarRotas}/>

        <AuthenticatedRoute path='/painel-veiculos' component={PainelGerenciarVeiculos}/>

        <AuthenticatedRoute path='/painel-cadastro-veiculo' component={PainelCadastrarVeiculo}/>

        <AuthenticatedRoute path='/painel-registro-manutencao-veiculo' component={PainelRegistrarManutencaoVeiculo}/>

        <AuthenticatedRoute path='/painel-itinerarios' component={PainelGerenciarItinerarios}/>

        <AuthenticatedRoute path='/painel-valores' component={PainelGerenciarPreco}/>

        <AuthenticatedRoute path='/painel-destinos' component={PainelVenderPassagem}/>

        <AuthenticatedRoute path='/painel-cadastro-mapa-veiculo' component={PainelCadastroVeiculo}/>

        <AuthenticatedRoute path='/painel-pesquisar-bilhete' component={PesquisarBilhete}/>

        <AuthenticatedRoute path='/painel-cadastro-bagagem' component={PainelCadastroBagagem}/>

        <AuthenticatedRoute path='/painel-bagagem' component={PainelGerenciarBagagens}/>

        <AuthenticatedRoute path='/painel-vendas' component={PainelGerenciarPedidos}/>

        <AuthenticatedRoute path='/painel-vendas-geral' component={PainelGerenciarPedidoGeral}/>

        <AuthenticatedRoute path='/painel-disponiveis-internet' component={PainelGerenciarDisponiveisInternet}/>

        <AuthenticatedRoute path='/painel-fechamento-caixa' component={PainelFechamentoCaixa}/>

        <AuthenticatedRoute path='/painel-fechamento-caixa-agencia' component={PainelFechamentoCaixaAgencia}/>

        <AuthenticatedRoute path='/detalhe-fechamento-agencia'
                            component={PainelDetalhamentoFechamentoCaixaAgencia}/>

        <AuthenticatedRoute path='/painel-mapas-veiculos' component={PainelGerenciarMapasVeiculos}/>

        <AuthenticatedRoute path='/menu-encomendas' component={MenuEncomendas}/>

        <AuthenticatedRoute path='/menu-bagagem' component={MenuBagagem}/>

        <AuthenticatedRoute path='/painel-encomendas' component={PainelGerenciarEncomendas}/>

        <AuthenticatedRoute path='/painel-cadastro-encomenda' component={PainelCadastroEncomenda}/>

        <AuthenticatedRoute path='/painel-configuracao-encomendas' component={PainelConfiguracaoEncomendas}/>

        <AuthenticatedRoute path='/painel-confirmar-entrega-encomendas' component={PainelConfirmarEntregaEncomendas}/>

        <AuthenticatedRoute path='/painel-gerenciar-encomendas-itinerario' component={PainelGerenciarEncomendasItinerario}/>

        <AuthenticatedRoute path='/recibo-encomenda' component={ReciboEncomenda}/>

        <AuthenticatedRoute path='/recibo-bagagem' component={ReciboBagagem}/>

        <AuthenticatedRoute path='/recibo-passagem' component={ReciboPassagem}/>

        <AuthenticatedRoute path='/recibo-cancelamento-reserva' component={ReciboCancelamentoReserva}/>

        <AuthenticatedRoute path='/selecao-empresa' component={SelecaoEmpresaAtuacao}/>

        <AuthenticatedRoute path='/painel-agencia' component={PainelGerenciarAgencias}/>

        <AuthenticatedRoute path='/gestao-empresa' component={PaginaPrincipalEmpresa}/>

        <AuthenticatedRoute path='/painel-lista-passageiros' component={PainelPassageirosItinerario}/>

        <AuthenticatedRoute path='/painel-transferencia-passageiros' component={PainelTransferirPassageirosItinerarios}/>

        <AuthenticatedRoute path='/itinerarios-para-transferencia' component={ItinerariosParaTransferencia}/>

        <AuthenticatedRoute path='/painel-recibos-itinerario' component={PainelRecibosItinerario}/>

        <AuthenticatedRoute path='/gestao' component={PaginaPrincipalGestao}/>

        <AuthenticatedRoute path='/painel-bloqueio-poltronas' component={PainelBloqueioPoltrona}/>

        <AuthenticatedRoute path='/mapa-viagem-itinerario' component={PainelMapaViagemItinerario}/>

        <AuthenticatedRoute path='/painel-ativacao-itinerario' component={PainelAtivacaoItineracioEmLote} />

        <AuthenticatedRoute path='/painel-remarcacao' component={PainelGerenciarRemarcacao}/>

        <AuthenticatedRoute path='/detalhe-fechamento' component={PainelDetalhamentoFechamentoCaixa}/>

        <AuthenticatedRoute path='/painel-detalhamento-financeiro-itinerario'
                            component={PainelDetalhamentoFinanceiroItinerario}/>

        <AuthenticatedRoute path='/painel-detalhamento-financeiro-itinerario-Encomenda'
                            component={PainelDetalhamentoFinanceiroItinerarioEncomenda}/>

        <AuthenticatedRoute path='/painel-alteracao-poltrona' component={PainelAlteracaoPoltrona}/>

        <AuthenticatedRoute path='/painel-configuracao-bpe' component={PainelConfiguracaoBPe}/>

        <AuthenticatedRoute path='/painel-configuracao-bilhete' component={PainelConfiguracaoBilhete}/>

        <AuthenticatedRoute path='/painel-relatorio-gerencial' component={PainelRelatorioGerencial}/>

        <AuthenticatedRoute path='/painel-relatorio-gerencial-agencia' component={PainelRelatorioGerencialAgencia}/>

        <AuthenticatedRoute path='/painel-usuario-bloqueado' component={PainelUsuarioBloqueado}/>

        <AuthenticatedRoute path='/menu-fechamento-caixa' component={MenuFechamentoCaixa}/>

        <AuthenticatedRoute path='/menu-relatorio' component={MenuRelatorio}/>

        <AuthenticatedRoute path='/menu-usuario' component={MenuUsuario}/>

        <AuthenticatedRoute path='/interessados-promocao' component={PainelGerenciarInteressadosPromocao}/>

        <AuthenticatedRoute path='/menu-itinerario' component={MenuItinerario}/>

        <AuthenticatedRoute path='/painel-resumo-financeiro' component={PainelResumoFinanceiro}/>

        <AuthenticatedRoute path='/painel-relatorio-itinerarios' component={PainelRelatorioItinerarios}/>

        <AuthenticatedRoute path='/painel-embarque-passageiros' component={PainelEmbarquePassageiros}/>

        <AuthenticatedRoute path='/painel-embarque-com-qrcode' component={PainelEmbarqueComQrCode}/>

        <AuthenticatedRoute path='/painel-cupons' component={PainelGerenciarCupom}/>

        <AuthenticatedRoute path='/painel-vexado-bi' component={PainelVexadoBI}/>

        <AuthenticatedRoute path='/painel-repasse-venda' component={PainelGerenciarRepasseVenda}/>

        <AuthenticatedRoute path='/painel-resumo-repasse' component={PainelResumoRepasse}/>

        <AuthenticatedRoute path='/painel-lista-reservas-repasse' component={PainelReservasRepasse}/>

        <AuthenticatedRoute path='/painel-configuracao-reserva-bpe' component={PainelConfiguracaoBpeReserva}/>

        <AuthenticatedRoute path='/painel-lista-calendario-disponibilidade-veiculo' component={PainelGerenciarCalendariosDisponibilidadeVeiculo} />

        <AuthenticatedRoute path='/painel-calendario-disponibilidade-veiculo' component={PainelGerenciarAgrupadoCalendarioDisponibilidadeVeiculo} />

        <AuthenticatedRoute path='/painel-cadastro-calendario-disponibilidade-veiculo' component={PainelCadastroCalendarioDisponibilidadeVeiculo} />

        <AuthenticatedRoute path='/painel-agendamento-viagem' component={PainelGerenciarAgendamentoViagem} />

        <AuthenticatedRoute path='/painel-cadastro-agendamento-viagem' component={PainelCadastroAgendamentoViagem} />

        <AuthenticatedRoute path='/painel-passageiros-agendamento-viagem' component={PainelPassageirosAgendamentoViagem} />

        <AuthenticatedRoute path='/painel-cte-os' component={PainelGerenciarEmissaoCteOS} />

        <AuthenticatedRoute path='/painel-cadastro-cte-os' component={PainelCadastroEmissaoCteOS} />

        <AuthenticatedRoute path='/painel-tomadores' component={PainelGerenciarTomador}/>

        <AuthenticatedRoute path='/nota-fiscal-cte-os' component={PainelNotaFiscalCteOs}/>

        <AuthenticatedRoute path='/nota-fiscal-cte' component={PainelNotaFiscalCte}/>

        <AuthenticatedRoute path='/menu-cteos' component={MenuCteos}/>

        <AuthenticatedRoute path='/menu-adesao-pontos' component={MenuAdesaoPontos}/>

        <AuthenticatedRoute path='/painel-cadastro-configuracao-ponto' component={PainelCadastroConfiguracaoPonto}/>

        <AuthenticatedRoute path='/painel-gerenciar-adesao-pontos' component={PainelGerenciarAdesaoPontos}/>

        <AuthenticatedRoute path='/menu-adesao-pontos-empresa' component={MenuAdesaoPontosEmpresa}/>

        <AuthenticatedRoute path='/painel-cadastro-configuracao-consumo-ponto' component={PainelCadastroConfiguracaoConsumoPonto}/>

        <AuthenticatedRoute path='/painel-gerenciar-clientes-empresa' component={PainelGerenciarClientesEmpresa}/>

        <AuthenticatedRoute path="/painel-centro-custo" component={PainelRegistrarCentroCusto} />

        <Route path='/painel-mensagem-autenticacao-dois-fatores' component={PainelMensagemAutenticacaoDoisFatores}/>
                
          <AuthenticatedRoute path='/' component={RedirectPagina}/>


      </Switch>
    )
  }
}

export default withRouter(AppRoutes)
